<template>
    <div class="topic-item cf" @click="openPage">

        <v-image class="fl topic-item-img" :src="data.picture" />

        <div class="topic-item-content relative fr">

            <div class="topic-item-title">#{{data.title}}#</div>

            <div class="topic-item-text line1">{{ data.intro }}</div>

            <div class="topic-item-tag absolute">{{ data.type == 1 ? '热议' : data.type == 2 ? '投票' : '观点PK' }}</div>

        </div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
import vImage from '@/components/image';
export default {
    name: "layout-topic-item",
    mixins: [mixin],
    components: {
        vImage
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            }
        }
    }
}
</script>

<style scoped src="./style.css"></style>
